import React, { useState } from 'react';
import { csrfParamToken } from '../../../../../jobs_page/src/utils/utils'

export type Country = {
  name: string;
  slug: string;
  placeholder: string;
};

export type CountryZipFormProps = {
  country: string;
  nearmeFormAction: string;
  cta: string;
  availableCountries: Array<Country>;
  countryPlaceholders: Record<string, string>;
};

export const CountryZipForm = ({
  country,
  nearmeFormAction,
  cta,
  availableCountries = [],
  countryPlaceholders,
}: CountryZipFormProps) => {
  const [selectedCountry, setSelectedCountry] = useState(country)
  const [countryPlaceholder, setCountryPlaceholder] = useState(countryPlaceholders[country])

  const handleChange = (e) => {
    setSelectedCountry(e.target.value)
    setCountryPlaceholder(countryPlaceholders[e.target.value])
  };
  const { param, token } = csrfParamToken();

  return (
    <div className="lg:mt-12 flex items-center">
      <form action={nearmeFormAction} acceptCharset="UTF-8" method="post" className="flex flex-wrap items-center justify-start text-sm lg:text-base">
        <select
          className="py-3 pl-7 pr-14 mr-3 mb-3 bg-cashew-dark rounded-full appearance-none text-sm leading-6"
          onChange={handleChange}
          name="country_code"
          value={selectedCountry}
        >
          {availableCountries.map((availableCountry) => (
            <option
              value={availableCountry.slug}
              key={availableCountry.slug}
            >
              {availableCountry.name}
            </option>
          ))}
        </select>
        <input
          className="py-3 pl-7 pr-14 mr-3 mb-3 border border-kale-light bg-cashew rounded-full"
          type="text"
          name="zipcode"
          placeholder={countryPlaceholder}
        />
        {param && token && (
          <input type="hidden" name={param} value={token} />
        )}
        <input type="hidden" name="commit" value="Search" />
        <button className="py-3 px-7 mb-3 bg-kale text-cashew rounded-full" type="submit" value={cta}>{cta}</button>
      </form>
    </div>
  );
};
